import Box from "@mui/material/Box"
import { MomentFormats } from "app-constants/constants"
import { createPath, ROUTE } from "app-constants/routing"
import Card from "components/Card"
import InfiniteHorizontalScroller from "components/InfiniteHorizontalScroller"
import { ActivityIndicator } from "components/activity-indicator"
import useRelativeTime from "hooks/useRelativeTime"
import useCurrent from "lib/use-current"
import ConventionSession from "models/convention-api/v1/ConventionSession"
import moment from "moment-timezone"
import pluralize from "pluralize"
import React, { useState } from "react"

interface SessionsListProps {
  convention: any
  institutionId: string
}

const SessionsHorizontalList = (props: SessionsListProps) => {
  const { convention, institutionId } = props
  const current = useCurrent()
  const [loading, setLoading] = useState(false)
  // @ts-ignore
  const { config } = current

  const sessions = ConventionSession.useMore({
    limit: 10,
    filter: {
      institution_id: institutionId,
      convention_id: convention.id,
      when: `now_and_upcoming`,
    },
    includes: ["convention_exhibitor"],
  })

  const loadMore = async () => {
    setLoading(true)
    await sessions.loadMore()
    setLoading(false)
  }

  if (!sessions.data)
    return (
      <Box display="flex" flexDirection="column">
        <ActivityIndicator />
      </Box>
    )

  return (
    <>
      <InfiniteHorizontalScroller
        hasMore={sessions.hasMore}
        loading={sessions.isLoading || loading}
        loadMore={loadMore}
        key={convention.id}
        title={
          convention.convention_id
            ? `Upcoming ${pluralize(config.session_copy_text, convention.session_count)} (${
                convention.session_count
              })`
            : `Upcoming ${pluralize(config.session_copy_text, convention.session_count)} for ${
                convention.name
              } (${convention.session_count})`
        }
        emptyStateMessage="No upcoming live sessions..."
        scrollSpeed={300}>
        {sessions.data?.map((session) => {
          // TODO: Refactor it! It's a temporary fix, to prevent `nested hooks error`
          function Component() {
            const formattedStartTime = moment(session.start_at).format(
              MomentFormats.dateTimeFullMonth,
            )

            const formattedEndTime = moment(session.end_at).format(MomentFormats.timeOnlyWithZone)

            const startAt = moment(session.start_at)
            const endAt = moment(session.end_at)
            const sessionRelativeTime = useRelativeTime({ startAt, endAt })

            const isSessionLive = sessionRelativeTime.during

            const conventionId = session.convention_exhibitor?.convention_convention_id as string
            const sessionId = session.id

            return (
              <Card
                imageUrl={session.promotional_image_thumb_url}
                title={session.name}
                subTitle={session?.convention_exhibitor?.exhibitor_name || "N/A"}
                footerText={`${formattedStartTime} - ${formattedEndTime}`}
                redirect={createPath({
                  path: ROUTE.CONVENTION_SESSION,
                  params: {
                    conventionId,
                    sessionId,
                  },
                })}
                // @ts-ignore
                coverTagText={isSessionLive ? "LIVE" : null}
              />
            )
          }

          return <Component key={session.id} />
        })}
      </InfiniteHorizontalScroller>
    </>
  )
}

export default SessionsHorizontalList
